import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import AppHeader from '@shared/components/AppHeader';
import PhoenixLogo from '@/assets/images/phoenix-logo.png';
import { useUserStore } from '@/store/Userdetails';
import { clearAll } from '@/helpers/auth';
import Notifications from '@/navigation/Notification';
import GlobalSearch from './GlobalSearch';

const APP_LOGO = { src: PhoenixLogo, alt: 'Phoenix Logo' };

const Header = ({ onOpenSidebar }) => {
  const navigate = useNavigate();
  const { userData } = useUserStore(
    (state) => ({
      userData: state.userData,
    }),
    shallow
  );
  const userDetails = userData?.data?.responseData?.userData;
  const firstName = userDetails?.contact?.[0]?.firstName ?? userDetails?.user?.[0]?.firstName ?? '';
  const lastName = userDetails?.contact?.[0]?.lastName ?? '';

  useEffect(() => {
    if (userData?.data?.responseData?.userData?.user[0].firstName) {
      return;
    } else {
      clearAll();
      navigate('/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ navigate, userData?.data?.responseData?.name ]);

  const goHome = useCallback(() => navigate('/'), [ navigate ]);

  const user = useMemo(() => ({
    initials: `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase(),
    name: lastName ? `${firstName} ${lastName.charAt(0)}.` : firstName,
  }), [ firstName, lastName ]);

  const userMenu = useMemo(() => [
    {
      key: 'logout',
      label: 'Logout',
      onClick: () => {
        clearAll();
        navigate(`/login?return_url=${encodeURIComponent(window.location.pathname)}`);
      },
    },
  ], [ navigate ]);

  const search = useMemo(() => <GlobalSearch />, []);
  const notifications = useMemo(() => <Notifications />, []);

  return (
    <AppHeader
      appLogo={APP_LOGO}
      onLogoClick={goHome}
      search={search}
      notifications={notifications}
      user={user}
      userMenu={userMenu}
      onOpenSidebar={onOpenSidebar}
    />
  );
};

export default Header;
